export default {
p20bbe7f2: "M3840 621V0L0 287.526V621H3840Z",
pdf82600: "M3840 726V0C2589.57 246.696 2110.26 383.709 0 635.424V726H3840Z",
pef1da00: "M3840 780.548V0C3840 0 1841 826.504 0 943.481V1034L3840 780.548Z",
}
